<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card
            :class="cardClass"
            color="grey darken-2"
            @click="cardClicked"
    >
        <v-tooltip top color="primary">
            <template v-slot:activator="{ on }">

                <v-sheet
                        v-on="on"
                        class="v-sheet--offset mx-auto"
                        color="primary"
                        elevation="12"
                        max-width="calc(100% - 32px)"
                >
                    <v-sparkline

                            :labels="sparkLineLabels"
                            :value="sparkLineValues"
                            color="white"
                            line-width="2"
                            padding="16"
                            smooth
                            auto-draw
                    ></v-sparkline>

                </v-sheet>
            </template>
            <span>
                    This chart displays activity variations in the past 15 weeks
                </span>
        </v-tooltip>

        <v-card-text class="pt-0">

            <v-tooltip :disabled="!totalCount" top color="primary">
                <template v-slot:activator="{ on }">
                    <div v-on="on">
                        <div class="title mb-2">{{ title }} {{ boxValue.toLocaleString() }}{{postfix}}</div>
                        <div class="subtitle-1 font-weight-light grey--text text--lighten-2">{{subTitle}}</div>
                    </div>
                </template>
                <div v-if="totalCount">
                    Total count: {{totalCount.toLocaleString()}}
                </div>
            </v-tooltip>

            <div v-if="hint">
                <v-divider class="my-2"></v-divider>
                <v-icon class="mr-2" small color="grey lighten-1">
                    mdi-information-outline
                </v-icon>
                <span class="caption grey--text text--lighten-1 font-weight-light">{{hint}}</span>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>

    export default {

        props: {
            'value': {
                type: Number,
                required: true,
                default: 0,
            },
            'postfix': {
                type: String,
                required: false,
                default: '',
            },
            'title': {
                type: String,
                required: true,
            },
            'subTitle': {
                type: String,
                required: true,
            },
            'hint': {
                type: String,
                required: false,
                default: null,
            },
            'totalCount': {
                type: Number,
                required: false,
                default: null,
            },
            'height': {
                type: Number,
                required: false,
                default: 100
            },
            'color': {
                type: String,
                required: false,
                default: 'primary'
            },
            'loading': {
                type: Boolean,
                required: false,
                default: false,
            },
            'sparkLabels': {
                type: Array,
                required: false,
                default: () => null,
            },
            'sparkValues': {
                type: Array,
                required: false,
                default: () => null
            },
            'clickable': {
                type: Boolean,
                required: false,
                default: false,
            }
        },

        data() {
            return {

            }
        },

        computed: {

            cardClass() {
                let style = 'ma-2 mt-5';
                if (!this.clickable) style+=' cursor-override';
                return style;
            },

            boxValue() {
                return this.value;
            },

            sparkLineValues() {
                if (this.sparkValues) return this.sparkValues;
                return [0, 0];
            },

            sparkLineLabels() {
                if (this.sparkLabels) return this.sparkLabels;
                return [' ', ' '];
            }
        },

        methods: {
            cardClicked() {
                if (this.clickable) {
                    this.$emit('click');
                }
            }
        }

    }
</script>

<style scoped>

    .cursor-override {
        cursor: default !important
    }

    .v-sheet--offset {
        top: -24px;
        position: relative;
    }
</style>
